module.exports = __webpack_public_path__ + "img/App_qrcode.2cb78bb0.jpg";